/*
 |--------------------------------------------------------------------------
 | UI / getters.js
 |--------------------------------------------------------------------------
 */

export default {
    isMobile: state => state.global.isMobile,
    isDesktop: state => !state.global.isMobile,
    viewportHeight: state => state.viewport.height,
    recommendation: state => state.overlay.recommendation,
    feedback: state => state.overlay.feedback,
    map: state => state.overlay.map,
    translation: state => state.global.translation,
    detectedLanguage: state => state.global.detectedLanguage,
    currentCoordinates: state => state.global.currentCoordinates
}
